import { Injectable } from '@angular/core';
import {  MatDialog } from '@angular/material/dialog';
import { CompanySfAsyncExportComponent } from '../../results/companies/modules/company-sf-async-export/company-sf-async-export.component';
import { OfflineExportsExportRequestDto } from '../dto';
import { LEGACY_THEME_CLASS } from '../constants';
import { Observable } from 'rxjs';
import { CompanyHsAsyncExportComponent } from '../../results/companies/modules/company-hs-async-export/company-hs-async-export.component';

@Injectable({
    providedIn: 'root',
})
export class CompanyAsyncExportService {
    constructor(private readonly matDialog: MatDialog) {
    }

    openSalesforceAsyncExports(data: OfflineExportsExportRequestDto): Observable<any> {
        return this.matDialog.open(CompanySfAsyncExportComponent, {
            panelClass: ['modal-lg', LEGACY_THEME_CLASS],
            data,
        }).afterClosed();
    }

    openHubspotAsyncExports(data: OfflineExportsExportRequestDto): Observable<any> {
        return this.matDialog.open(CompanyHsAsyncExportComponent, {
            panelClass: ['modal-lg', LEGACY_THEME_CLASS],
            data,
        }).afterClosed();
    }
}
